import "./App.css";
import PortfolioContainer from "./PortfolioContainer/ProfileContainer";
function App() {
  return (
    <div className="App">
      <PortfolioContainer />
    </div>
  );
}

export default App;
